'use strict';

module.exports.customDomainStatus = require('./customDomainStatus');
module.exports.market = require('./market');
module.exports.migrationStatus = require('./migrationStatus');
module.exports.migrationM365Options = require('./migrationM365Options');
module.exports.plData = require('./plData');
module.exports.resellerType = require('./resellerType');
module.exports.socialMediaType = require('./socialMediaType');
module.exports.supportOption = require('./supportOption');
module.exports.taxesAndFees = require('./taxesAndFees');
module.exports.tldOffering = require('./tldOffering');